import { render, staticRenderFns } from "./TPPPage.vue?vue&type=template&id=e39b7ba6&"
import script from "./TPPPage.vue?vue&type=script&lang=js&"
export * from "./TPPPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports